import { css } from 'lit';
import sharedStyles from '../../../shared/styles';

export default [
  sharedStyles,
  css`
    #partners-registration-form-submit-msg.alert {
      padding: 15px;
      margin-bottom: 20px;
      border: 1px solid transparent;
      border-radius: 4px;
    }

    #partners-registration-form-submit-msg.alert-info {
      background-color: #d9edf7;
      border-color: #bce8f1;
      color: #31708f;
    }

    .partners-registration-form-container .error-msg,
    .partners-registration-form-container .submit-msg  {
      text-align: left;
      margin-bottom: 1rem;
    }

    .partners-registration-form-container tenable-form-group,
    #partners-registration-form-desc,
    #partners-registration-form-error-msg {
      text-align: left;
    }

    .partners-registration-form-container tenable-form-group label small {
      font-weight: normal;
    }

    .partners-registration-form-container .registration-btn {
      --tenable-btn-primary-background-color:  #1E2426;
      --tenable-btn-primary-border-color: #1E2426;
      --tenable-btn-primary-disabled-background-color: var(--tenable-btn-primary-background-color, #1E2426);
      --tenable-btn-primary-disabled-border-color: var(--tenable-btn-primary-background-color, #1E2426);
      --tenable-button-width: fit-content;
      text-align: center;
    }

    .partners-registration-form-container #partners-registration-form {
      --tenable-input-placeholder-color: #ccc;
    }
  `,
];
